import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "ll-menu-divider"
};
const _hoisted_2 = ["data-cy", "onClick"];
const _hoisted_3 = {
  class: "ll-menu-title"
};
const _hoisted_4 = {
  key: 1,
  class: "ll-menu-subtitle"
};
import { ref, watch } from 'vue';
export default {
  __name: 'LlMenu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: ''
    },
    buttonVariant: {
      type: String,
      default: 'flat'
    },
    buttonColor: {
      type: String,
      default: 'grey-lighten-4'
    },
    buttonSize: {
      type: String,
      default: 'default'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    listClass: {
      type: String,
      default: ''
    },
    listDensity: {
      type: String,
      default: 'default'
    },
    nav: {
      type: Boolean,
      default: false
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    location: {
      type: String,
      default: 'bottom'
    },
    offset: {
      type: [String, Number, Array],
      default: 1
    },
    minWidth: {
      type: [String, Number],
      default: 200
    },
    maxWidth: {
      type: [String, Number],
      default: 300
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    dataCy: {
      type: String,
      default: ''
    },
    openOnHover: {
      type: Boolean,
      default: false
    }
  },
  emits: ['item-click', 'menu-open', 'menu-close'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const menuOpen = ref(false);
    const handleItemClick = item => {
      if (item.disabled) return;
      emit('item-click', item);
      if (item.action && typeof item.action === 'function') {
        item.action();
      }
      if (props.closeOnContentClick) {
        closeMenu();
      }
    };
    const closeMenu = () => {
      menuOpen.value = false;
      emit('menu-close');
    };
    const openMenu = () => {
      menuOpen.value = true;
      emit('menu-open');
    };

    // Watch menu state
    watch(menuOpen, newValue => {
      if (newValue) {
        emit('menu-open');
      } else {
        emit('menu-close');
      }
    });
    __expose({
      closeMenu,
      openMenu,
      isOpen: menuOpen
    });
    return (_ctx, _cache) => {
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createBlock(_component_v_menu, {
        modelValue: menuOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => menuOpen.value = $event),
        "close-on-content-click": __props.closeOnContentClick,
        location: __props.location,
        offset: __props.offset,
        "min-width": __props.minWidth,
        "max-width": __props.maxWidth,
        "z-index": __props.zIndex,
        "open-on-hover": __props.openOnHover
      }, {
        activator: _withCtx(({
          props: menuProps
        }) => [_renderSlot(_ctx.$slots, "activator", {
          props: menuProps,
          isOpen: menuOpen.value
        }, () => [_createElementVNode("div", _mergeProps(menuProps, {
          class: __props.buttonClass,
          style: {
            "cursor": "pointer"
          }
        }), _toDisplayString(__props.buttonText), 17)])]),
        default: _withCtx(() => [_ctx.$slots.content ? _renderSlot(_ctx.$slots, "content", {
          key: 0,
          close: closeMenu
        }) : (_openBlock(), _createElementBlock("ul", {
          key: 1,
          class: _normalizeClass(["ll-menu-list", __props.listClass])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.id || index
          }, [item.divider ? (_openBlock(), _createElementBlock("li", _hoisted_1, [...(_cache[1] || (_cache[1] = [_createElementVNode("hr", null, null, -1)]))])) : (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass(["ll-menu-item", [item.class, {
              'disabled': item.disabled
            }]]),
            "data-cy": item.dataCy,
            onClick: $event => handleItemClick(item)
          }, [item.icon ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass([item.icon, "ll-menu-icon"])
          }, null, 2)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1), item.subtitle ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.subtitle), 1)) : _createCommentVNode("", true)], 10, _hoisted_2))], 64);
        }), 128)), _renderSlot(_ctx.$slots, "items", {
          close: closeMenu
        })], 2))]),
        _: 3
      }, 8, ["modelValue", "close-on-content-click", "location", "offset", "min-width", "max-width", "z-index", "open-on-hover"]);
    };
  }
};